import React from 'react';
import { Validation } from '../../ReusableComponents/NewDesign/Layout/Layout';

function SponsorAndExecApproval() {
  return (
    <Validation
      title="Thank you. We've received your answers."
      text="This application will now go through Sponsor and Executive approval."
    />
  );
}

export default SponsorAndExecApproval;
